import find from 'lodash/find';
import { useTranslation } from 'react-i18next';

import { useCoverageType } from '../../hooks/useCoverageType';
import { useLagoon } from '../../hooks/useLagoon';
import { Constants } from '../Constants';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { StyledDiv } from '../ConstantsStyles';
import { Markdown } from '../Markdown';
import { ModalWithTracking } from '../ModalWithTracking/ModalWithTracking';
import { getBestMatchOptionKey } from './SortByUtil';

type Props = {
  dataForAnalytics: DataForAnalytics;
  isOpen: boolean;
  setIsOpen: (a: boolean) => void;
};
export type CustomAttributesBlock = {
  correlationId: string;
  providerId: string;
  providerType: string;
};
interface DataForAnalytics {
  linkName: string;
  linkLocation: string;
  modalName: string;
  linkType?: string;
  customAttributesBlock?: CustomAttributesBlock;
}
export const InfoModal = ({ dataForAnalytics, isOpen, setIsOpen }: Props) => {
  const data = useLagoon('ui-messaging')();
  const modalContent = find(data, {
    key: ConstantsLagoon.CONTENT_FILTERS.INFO_MODAL_CONTENT,
  });

  const { t } = useTranslation();
  const coverageType = useCoverageType();

  return (
    <ModalWithTracking
      analyticsInfo={{
        ...dataForAnalytics,
      }}
      css={{
        'abyss-modal-header-title': {
          color: '$core.color.neutral.80',
        },
      }}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title={t(`SORT_OPTIONS.${getBestMatchOptionKey(coverageType)}`)}
      trackingType={Constants.ADOBE_TRACKING.MODAL_WITH_LINK_TRACKING}
    >
      <StyledDiv css={{ paddingBottom: '32px' }}>
        <Markdown>{modalContent?.message ?? ''}</Markdown>
      </StyledDiv>
    </ModalWithTracking>
  );
};
